import {Injectable} from "@angular/core";
import {UnsubscribeBaseServiceModel} from "../client/UnsubscribeBaseService.model";
import {AppData} from "../AppData";
import { HttpClient } from "@angular/common/http";
import {CompoApp} from "../CompoApp";
import {Observable} from "rxjs/internal/Observable";
import {UrlBuilder} from "../../models/frontend_entities/UrlBuilder";
import Constants from "../../Constants";
import {take} from "rxjs/operators";
import {MessageTypeDtoModel} from "../../models/designations-and-icon/message-type-dto-model";

@Injectable()
export class MessageTypeRequestService extends UnsubscribeBaseServiceModel {

  //region FIELDS
  private data: AppData;

  //endregion

  //region CONSTRUCTOR
  constructor(private http: HttpClient,
              private app: CompoApp) {
    super();
    this.data = app.data;
  }
  //endregion

  //region REQUEST METHODS
  createMessageType(model: MessageTypeDtoModel): Observable<MessageTypeDtoModel> {
    const url = new UrlBuilder(Constants.URLS.messages.type.save)
      .param('accessMode', this.data.getAccessMode())
      .param('lang', this.data.getLang())
      .build();

    return this.http.post<MessageTypeDtoModel>(url, model).pipe(take(1));
  }

  updateMessageType(model: MessageTypeDtoModel) : Observable<MessageTypeDtoModel> {
    const url = new UrlBuilder(Constants.URLS.messages.type.update)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<MessageTypeDtoModel>(url, model).pipe(take(1));
  }

  deleteMessageType(id: number) : Observable<void> {
    const url = new UrlBuilder(Constants.URLS.messages.type.delete)
      .param('id', id)
      .param('lang', this.data.getLang())
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.put<void>(url, null).pipe(take(1));
  }

  //endregion

}
